module.exports = __webpack_public_path__ + "img/hatch-thankyou-step2.f1ca94b2.svg";